const CONSENT_KEY = "kreuse_cookies_v1";

function hasConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) || "{}").choice === "accepted";
  } catch {
    return false;
  }
}

export function trackEvent(name, params = {}) {
  if (!hasConsent() || typeof window.gtag !== "function") return;
  window.gtag("event", name, { page_path: window.location.pathname, ...params });
}

export function handleTrackedClick(e) {
  const link = e.target.closest && e.target.closest("a[href]");
  if (!link) return;
  const href = link.getAttribute("href");
  if (href.startsWith("tel:")) trackEvent("click_phone", { link_url: href });
  else if (/wa\.me|whatsapp\.com/.test(href)) trackEvent("click_whatsapp", { link_url: href });
}
